<template>
  <v-dialog :value="value" persistent max-width="800">
    <v-progress-linear
      v-if="loading"
      absolute
      top
      color="primary"
      indeterminate
    />
    <v-card class="pa-5">
      <v-card-title class="px-0 pt-0">
        Bauvorhaben erstellen
        <v-spacer />
        <v-btn :disabled="loading" icon @click="closeDialog">
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>
      <p class="mb-0">Nach diesem Schritt wird der Interessent zum Kunden.</p>
      <p class="font-weight-bold">
        Dieser Schritt kann nicht rückgängig gemacht werden!
      </p>
      <v-card-actions class="px-0 pb-0">
        <v-spacer />
        <v-btn
          depressed
          :disabled="loading"
          large
          :loading="loading"
          class="mr-2"
          @click="closeDialog"
          >Abbrechen</v-btn
        >
        <v-btn
          depressed
          :disabled="loading"
          large
          :loading="loading"
          color="cta"
          class="white--text"
          @click="$emit('dialog:action')"
          >Erstellen</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from "@mdi/js";

export default {
  name: "CustomerCreationDialog",
  data() {
    return {
      icons: {
        mdiClose,
      },
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
    emitValue() {
      this.$emit("dialog:input");
    },
  },
};
</script>

<style scoped></style>
